import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#F3F4F6', gap: 10,
    }}>
      <div style={{ fontSize: 56, fontWeight: 700, color: '#E5E7EB', lineHeight: 1 }}>404</div>
      <div style={{ fontSize: 16, fontWeight: 600, color: '#374151' }}>Page not found</div>
      <div style={{ fontSize: 13, color: '#9CA3AF' }}>The page you're looking for doesn't exist.</div>
      <Link to="/" style={{ marginTop: 8, fontSize: 13, color: '#1D4ED8', fontWeight: 500 }}>
        ← Back to home
      </Link>
    </div>
  );
}
